angular.module('dpw.components').directive('dpwUpgradeTrial', [function () {
    return {
        restrict: 'A',
        scope: true,
        controllerAs: 'ctrl',
        templateUrl: 'dpw-upgrade-trial.component.html',
        controller: ['$scope', function ($scope) {
            var self = this;

            self.billingPortalUrl = RCDPW.billingPortalUrl || 'https://billing-portal.ringcentral.com/api/oauth-login';

            self.cancel = function () {
                $scope.onClose && $scope.onClose();
            };
        }]
    };
}]);
